import { PropsWithChildren, ReactElement } from "react";

import { InnerWrapper, Wrapper } from "./components";

// eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
const ControlsContainer = ({ children }: PropsWithChildren): ReactElement => (
  <Wrapper>
    <InnerWrapper>{children}</InnerWrapper>
  </Wrapper>
);

export default ControlsContainer;
